import { render, staticRenderFns } from "./Comp22t2.vue?vue&type=template&id=210b04ec&scoped=true&"
import script from "./Comp22t2.vue?vue&type=script&lang=js&"
export * from "./Comp22t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp22t2.vue?vue&type=style&index=0&id=210b04ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b04ec",
  null
  
)

export default component.exports